import { useMemo } from 'react';

import { Operation, SharesTitle } from 'types';

import sharesTitlesStatus from 'modules/partners/pages/ShareTitleList/constants/sharesTitlesStatus';

import { getTitleByOperation } from '../utils/getTitleByTransaction';

type GetOperationTitleDataProps = {
  sharesTitles: SharesTitle[];
  operation: Operation;
};
const CANCELLED_STATUS = sharesTitlesStatus[2].value;

export const useGetOperationTitleData = ({
  sharesTitles,
  operation,
}: GetOperationTitleDataProps) => {
  const data = useMemo(() => {
    if (!operation) {
      return {
        operationTitleId: '',
        titleWatermarkText: '',
      };
    }

    const operationTitle = getTitleByOperation({ sharesTitles, operation });

    const titleNumber = operationTitle?.number;
    const titleWatermarkText =
      operationTitle?.status === CANCELLED_STATUS ? 'TÍTULO CANCELADO' : '';

    return {
      operationTitleId: operationTitle?._id || '',
      titleWatermarkText,
      titleNumber,
    };
  }, [operation, sharesTitles]);

  return { data };
};
